import React from 'react';
import { Alert, Button } from 'reactstrap';

const RebootNotification = ({ macAddress, deviceId, onReboot }) => {
  return (
    <Alert rowSpan={5} color="warning">
      <span>{macAddress} Needs to be rebooted</span>
      <span>
        <Button color="primary" onClick={() => onReboot(deviceId)}>
          Reboot
        </Button>
      </span>
    </Alert>
  );
};

export default RebootNotification;
